
/**
 * Language resources for the User module.
 * @typedef {Object} UserTextResources
 * @property {string} calorieLogs - Text for calorie logs.
 * @property {string} email - Text for email.
 * @property {string} emailRequired - Text for email required.
 * @property {string} emailInvalid - Text for email invalid.
 * @property {string} enterEmail - Text for enter email.
 * @property {string} title - Text for title.
 * @property {string} date - Text for date.
 * @property {string} dateRequired - Text for date required.
 * @property {string} time - Text for time.
 * @property {string} mealType - Text for meal type.
 * @property {string} foodItem - Text for food item.
 * @property {string} calories - Text for calories.
 * @property {string} search - Text for search.
 * @property {string} reset - Text for reset.
 * @property {string} srNo - Text for sr no.
 * @property {string} noData - Text for no data.
 */
export const text = {
    calorieLogs: "Calorie Logs",
    description: "Enter your email and select a date to load your calorie logs",
    email: "Email",
    emailRequired: "Please enter email",
    emailInvalid: "Please enter a valid email",
    enterEmail: "Enter email address",
    title: "Calorie Logs",
    date: "Date",
    selectDate: "Select Date",
    dateRequired: "Please select a date",
    time: "Time",
    mealType: "Meal Type",
    foodItem: "Food Item",
    calories: "Calories",
    search: "Search",
    reset: "Reset",
    srNo: "Sr. No",
    noData: "No Data Found",
    logsLoaded: "Calorie logs loaded successfully",
    errorLoadingLogs: "Error loading calorie logs",
    totalCalories: "Total Calories",
    totalRecords: "Total records: {total}",
};
